var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { mTitle2, wBody1 } from '@teamsparta/design-system';
import { Device } from '../../../styles/_variables';
var CtaBtn = function (_a) {
    var children = _a.children, bgColor = _a.bgColor, color = _a.color, onClickAction = _a.onClickAction, isInactive = _a.isInactive, hasMobileMargin = _a.hasMobileMargin;
    return (_jsx(Container, __assign({ onClick: onClickAction, bgColor: bgColor, color: color, isInactive: isInactive, hasMobileMargin: hasMobileMargin }, { children: children })));
};
export default CtaBtn;
var Container = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  /* for button css */\n  border: none;\n\n  cursor: ", ";\n  width: 99.5%;\n  height: 56px;\n  background: ", ";\n  ", ";\n  color: ", ";\n  border-radius: 60px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n\n  ", " {\n    ", ";\n    height: 54px;\n    ", ";\n    color: ", ";\n  }\n"], ["\n  /* for button css */\n  border: none;\n\n  cursor: ", ";\n  width: 99.5%;\n  height: 56px;\n  background: ", ";\n  ", ";\n  color: ", ";\n  border-radius: 60px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n\n  ", " {\n    ", ";\n    height: 54px;\n    ", ";\n    color: ", ";\n  }\n"])), function (_a) {
    var isInactive = _a.isInactive;
    return (isInactive ? 'default' : 'pointer');
}, function (_a) {
    var bgColor = _a.bgColor;
    return bgColor;
}, wBody1, function (_a) {
    var color = _a.color;
    return color;
}, Device.Mobile, function (_a) {
    var hasMobileMargin = _a.hasMobileMargin;
    return (hasMobileMargin ? "width: calc(100vw - 64px)" : '');
}, mTitle2, function (_a) {
    var color = _a.color;
    return color;
});
var templateObject_1;
//# sourceMappingURL=CtaBtn.js.map